import {Component, OnInit, ViewChild, Optional, ViewContainerRef} from '@angular/core';
import {DialogService} from 'ng2-bootstrap-modal';
import {DataTableDirective} from 'angular-datatables';
import {ModulesService} from '../../_services/modules.service';
import {AddModulesComponent} from './add-modules/add-modules.component';
import {EditModulesComponent} from './edit-modules/edit-modules.component';
import {SendSignalService} from "../../_services/send-signal.service";

@Component({
    selector: 'app-modules',
    templateUrl: './modules.component.html',
    styleUrls: ['./modules.component.css']
})
export class ModulesComponent implements OnInit {

    searchWord: string;
    delayTimer: any;
    dtOptions: DataTables.Settings = {};
    @ViewChild(DataTableDirective)
    dtElement: DataTableDirective;

    //declare parameters object
    parameters: any = {};
    //declare callback object
    callback: any = {};
    constantModules: any;

    constructor(
        private modulesService: ModulesService,
        private dialogService: DialogService,
        private sendSignalService: SendSignalService) {

        this.modulesService.getConstantModule().subscribe(constants => {
            this.constantModules = constants;
        });
    }

    ngOnInit() {
        this.registerTable();
        if ($('.content-wrapper').height() < 838) {
            $('.content-wrapper').css('min-height', 838);
        }
    }

    registerTable() {
        let self = this;
        this.dtOptions = {
            language: {
                emptyTable: "データが存在しません"
            },
            order: [[0, "desc"]],
            searching: false,
            lengthChange: false,
            serverSide: true,
            pageLength: 15,
            ajax: function (parameters, callback, settings) {
                parameters["search"]["value"] = self.searchWord || '';

                //assign parameters object
                self.parameters = parameters;

                //assign callback object
                self.callback = callback;

                self.modulesService.gets(parameters).subscribe(result => {
                    callback({
                        draw: parameters['draw'],
                        data: result.data,
                        recordsTotal: result.data.length,
                        recordsFiltered: result.recordsTotal
                    });
                });
            },
            columns: [
                {
                    title: "ID",
                    data: "id",
                    name: "id",
                    className: "text-justify"
                },
                {
                    title: "モジュール名",
                    data: "module_name",
                    name: "module_name",
                    className: "all text-justify"
                },
                {
                    title: "マネー",
                    data: "money",
                    name: "money",
                    className: "all text-justify"
                },
                {
                    title: "マネーのカテゴリ",
                    data: "category_name",
                    name: "category_name",
                    className: "all text-justify"
                },
                {
                    title: "",
                    data: "btn_is_active_module",
                    width: '60px',
                    className: "all text-center",
                    orderable: false
                },
                {
                    title: "",
                    data: function (d) {
                        return `<button class="btn btn-sm btn-edit">編集</button>`;
                    },
                    width: '60px',
                    className: "all text-center",
                    orderable: false
                },
            ],
            rowCallback: (row: Node, data: any[] | Object, index: number) => {
                const self = this;

                $('.btn-edit', row).bind('click', () => {
                    self.openEdit(data);
                });

                $('.btn-is-active', row).bind('click', () => {
                    self.IsAdminApproved(data);
                });

                if (data['is_active_module'] == 0) {
                    $(row).css('background-color', '#3c8dbc');
                    var btn_active_bot = $(row).find('td').find('.btn-active-module');
                    btn_active_bot.css({
                        'background-color': 'HotPink',
                        'border-color': 'HotPink'
                    });
                    btn_active_bot.mouseover(function () {
                        btn_active_bot.css('opacity', '0.8');
                    });
                    btn_active_bot.mouseout(function () {
                        btn_active_bot.css('opacity', '1');
                    });
                }

                var btn_edit = $(row).find('td').find('.btn-edit');
                btn_edit.css({
                    'background-color': 'deepskyblue',
                    'color': '#fff'
                });
                btn_edit.mouseover(function () {
                    btn_edit.css('opacity', '0.9');
                });
                btn_edit.mouseout(function () {
                    btn_edit.css('opacity', '1');
                });

                return row;
            }
        };
    }

    rerenderDataTable(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw();
        });
    }

    loadCurrentPage() {
        //get parameters and retrive result of current page 
        this.modulesService.gets(this.parameters).subscribe(result => {
            //use callback function
            this.callback({
                //retrive draw current
                draw: this.parameters['draw'],
                //retrive data of current page
                data: result.data,
                //retrive number records per page
                recordsTotal: result.data.length,
                //retrive total records
                recordsFiltered: result.recordsTotal
            });
        });
    }

    IsAdminApproved(data) {
        this.modulesService.activeModules(data).subscribe(data => {
            if (!data.error) {
                this.loadCurrentPage();
            } else {
                alert(data.message);
            }
        }, error => {
            alert(error.json().message);
        });
    }

    openModalAddMail() {
        let self = this;
        this.loadFunctionSendSignalPrice(null, (resFunctionSendSignal) => {
            this.dialogService.addDialog(AddModulesComponent, {
                constantModules: self.constantModules,
                functionSendSignalPrice: resFunctionSendSignal
            }).subscribe((isAccess) => {
                if (isAccess) {
                    this.loadCurrentPage();
                }
            });
        });
    }

    openEdit(data) {
        let arrDataModule = [];
        this.modulesService.getModuleFunctionById(data.id).subscribe(resDataModule => {
            resDataModule.forEach(item => {
                arrDataModule.push(item);
            });
            this.loadFunctionSendSignalPrice(data.id, (functionSendSignalPrice) => {
                this.dialogService.addDialog(EditModulesComponent,
                    {
                        id: data.id,
                        moduleName: data.module_name,
                        money: data.money,
                        arrDataModule: arrDataModule,
                        categoryMoney: data.category_money_id,
                        constantModules: this.constantModules,
                        functionSendSignalPrice: functionSendSignalPrice
                    }
                ).subscribe((isAccess) => {
                    if (isAccess) {
                        this.loadCurrentPage();
                    }
                });
            });
        });
    }

    loadFunctionSendSignalPrice(moduleID?: any, callback?: any) {
        this.sendSignalService.postFunctionForUser({moduleID: moduleID}).subscribe(childFunctionForUser => {
            callback(childFunctionForUser);
        });
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/modules/modules.component.ts